module.exports = __webpack_public_path__ + "static/media/tele4.b8204559.svg";